import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { Container, Box } from "@mui/material";
import SubscriptionDetails from "./SubscriptionDetails";
import SubscriptionDemo from "./SubscriptionDemo";
import SubscriptionGatedPage from "./SubscriptionGatedPage";
import MeteredBillingDemo from "./MeteredBillingDemo";

/**
 * SubscriptionsPage - React MUI routing component for Subscriptions & Billing functionality
 *
 * This component provides:
 * - Routing for subscription management and billing views
 * - Navigation between subscription sections
 * - Error boundary for subscription sections
 */

const SubscriptionsPage: React.FC = () => {
  return (
    <Container maxWidth="lg">
      <Box sx={{ py: 3 }}>
        <Routes>
          <Route index element={<SubscriptionDetails />} />
          <Route path="demo" element={<SubscriptionDemo />} />
          <Route
            path="subscription-gated-page"
            element={<SubscriptionGatedPage />}
          />
          <Route path="metered-billing-demo" element={<MeteredBillingDemo />} />
          <Route path="*" element={<Navigate to="" replace />} />
        </Routes>
      </Box>
    </Container>
  );
};

export default SubscriptionsPage;
